import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div align="center">
                                            <img alt="" style={{maxWidth: '100%'}}
                                                 src={require('@images/How to reframe problems.png')}/>
                                        </div>

                                        <div className="ilead-contentarea">

                                            <div className="circle_title"><span className="heading"><img
                                                src={require('@images/greendot.jpg')}
                                                className="heading_image"/></span><span className="heading">isn't it interesting?</span>
                                            </div>
                                            <p>What do you see in this picture? </p>
                                            <div className="border_subtitle"><img
                                                src={require('@images/human-brain.png')}
                                                align="right" style={{paddingBottom: '10px'}}/>The human
                                                brain....
                                            </div>
                                            <p>Is a complex and largely mysterious organ. Our brains are
                                                able to process
                                                the outside world and help us to interact with it.
                                                Amazingly, our brain allows us to take different
                                                perspectives and see things from many alternative angles.
                                                Our brains are adaptable and fill in information gaps so we
                                                function without being overwhelmed with the amount of
                                                information in the world. So when you look at the picture
                                                here, depending on the
                                                perspective your brain chooses to take, you will see a
                                                different figure. </p>

                                            <div className="lightgreencontentbg keyquestionpad">
                                                <div className="border_subtitle">So, how does this work?
                                                </div>
                                                <p>In this picture you may see a young woman or an old lady.
                                                    Can you see both of them? If you
                                                    see the young woman and cannot see the old lady, then
                                                    look at the side of the young woman's face and chin as
                                                    this is the old lady's nose. The young woman's ear is
                                                    the old lady's eye.
                                                    Can you now see both? </p>
                                                <div className="uiheading"><p>This optical illusion is
                                                    called an ambiguous cognitive illusion<a
                                                        className="superscripttext"
                                                        href="further_info.php?page=1&amp;course=300"><sup>1</sup></a> and
                                                    demonstrates how our
                                                    brains can take the same piece of information and see
                                                    different meanings. This means that what we see and do
                                                    is dependent on our experience and perspective. We can
                                                    use our innate ability to see different perspectives to
                                                    reframe challenges. In this picture whilst our brains
                                                    initially see one image, by attending to different
                                                    elements we're able to change what we see.
                                                    So, on viewing the picture for a second time we can see
                                                    an alternative image using the same
                                                    information, which is both interesting and potentially
                                                    useful for us. </p></div>
                                            </div>

                                            <div className="border_subtitle para-first-pad">This tool can
                                                help
                                            </div>
                                            <p>At times, it can be difficult to understand how we can change
                                                our perspective or approach to think
                                                about issues in a different way. This tool is about <span
                                                    className="green brownbold">how to reframe problems</span> and
                                                will help you to
                                                understand how we can think about and successfully solve
                                                issues using a fresh perspective. </p>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}